import { Button, Col, Row, Switch, Form, Tooltip } from "antd";
import { Spinal } from "components/spinal/Spinal";
import { KotoDataModel } from "pages/beheer/dataproducten/models/kotoModel";
import { FC } from "react";
import { CardTable } from "../../../components/card-table";
import { errorHandler } from "../../../helpers/notification";
import { PercelenModel } from "./models/percelenMock";
import styles from "./styles.module.scss";

interface SwitchesProps {
  kotoData: KotoDataModel;
  isKlwReadOnly: boolean;
  isLoading: boolean;
  gebruikKoppeltoolKoolstofBodem: boolean;
  klwJaar: number;
}

export const Switches: FC<SwitchesProps> = ({
  kotoData,
  isKlwReadOnly,
  isLoading,
  gebruikKoppeltoolKoolstofBodem,
  klwJaar,
}) => {
  return (
    <CardTable>
      <CardTable.Header>
        <CardTable.Header.Title
          infoContent={
            <>
              <p>
                U kunt u hier aangeven of u gebruik wilt maken van de koppeltool
                voor het koppelen van Bodemmonsters aan RVO Gewasprecelen. Dat
                is mogelijk als u machtigingen heeft afgegeven voor het inlezen
                van deze gegevens. Bij het gebruik van de koppeltool kunt u nog
                ontbrekende bodemmonsters toevoegen. Door het koppelen wordt de
                indeling van uw areaal in fosfaatklassen en grondsoort (waarbij
                ook gebruik wordt gemaakt van grondwatertrappen) voor u berekend
                en ook het percentage blijvend grasland. Als u akkerbouwgewassen
                heeft dan is gelijk de oppervlakte bekend en behoeft u in het
                blok akkerbouw alleen nog de opbrengsten aan te geven. U ziet na
                een eerste keer gebruik van de koppeltool een blok met al uw
                gewaspercelen. U kunt dan nog evt. gewaspercelen selecteren en
                indien nodig ook nog handmatig toevoegen. Zie ook de toelichting
                bij het blok.
              </p>
              <p>
                Als u er niet voor kiest om de koppeltool te gebruiken of niet
                kunt gebruiken omdat er geen gegevens zijn ingelezen, dan dient
                u de nodige gegevens handmatig in te vullen.
              </p>
              <p>
                U kunt hier ook aangeven of u voor- of nagewassen en/of
                vanggewassen heeft. Zo ja dan verschijnt er een blok waar u dit
                kunt invullen.
              </p>
            </>
          }
        >
          Instellingen
        </CardTable.Header.Title>
      </CardTable.Header>
      <CardTable.Body>
        <Spinal initializing={false} loading={isLoading}>
          <Row className={styles.marginBottom5}>
            <Col span={9}>
              Gebruik de koppeltool voor het koppelen van RVO gewaspercelen en
              bodemanalyses:
            </Col>
            <Col className={styles.switchColumn} span={1}>
              <Form.Item noStyle name={["gebruikKoppeltool"]} hidden />
              <Form.Item noStyle shouldUpdate>
                {({ getFieldValue }) => {
                  const gebruikKoppeltool: PercelenModel["gebruikKoppeltool"] =
                    getFieldValue(["gebruikKoppeltool"]);

                  const toggle = (
                    <Switch
                      className={styles.alignSuper}
                      checked={gebruikKoppeltool}
                      disabled
                    />
                  );

                  if (kotoData.isKotoPercelenEnabled) {
                    return toggle;
                  }

                  return (
                    <Tooltip
                      style={{ width: "400px" }}
                      title={kotoData.kotoPercelenMelding}
                    >
                      {toggle}
                    </Tooltip>
                  );
                }}
              </Form.Item>
            </Col>

            {kotoData.isKotoPercelenEnabled && (
              <Col span={14}>
                <Form.Item noStyle shouldUpdate>
                  {({ getFieldValue }) => {
                    const gebruikKoppeltool: PercelenModel["gebruikKoppeltool"] =
                      getFieldValue(["gebruikKoppeltool"]);
                    const gebruikKoppeltoolKoolstofBodem: PercelenModel["gebruikKoppeltoolKoolstofBodem"] =
                      getFieldValue(["gebruikKoppeltoolKoolstofBodem"]);
                    return (
                      (gebruikKoppeltool || gebruikKoppeltoolKoolstofBodem) &&
                      !isKlwReadOnly && (
                        <Button
                          className={styles.KoppelToolBtn}
                          shape="round"
                          disabled
                        >
                          Koppeltool
                        </Button>
                      )
                    );
                  }}
                </Form.Item>
              </Col>
            )}
          </Row>

          {klwJaar >= 2023 && gebruikKoppeltoolKoolstofBodem && (
            <Row className={styles.marginBottom5}>
              <Col span={9}>Koppeltool gebruiken voor Bodemkoolstof</Col>
              <Col className={styles.switchColumn} span={1}>
                <Form.Item
                  noStyle
                  name={["gebruikKoppeltoolKoolstofBodem"]}
                  valuePropName="checked"
                >
                  <Switch className={styles.alignSuper} disabled />
                </Form.Item>
              </Col>
            </Row>
          )}
          <Row className={styles.marginBottom5}>
            <Col span={9}>
              Gebruikt u voorgewassen, nagewassen of vanggewassen in uw
              bouwplan:
            </Col>
            <Col className={styles.switchColumn} span={1}>
              <Form.Item
                noStyle
                name={["gebruikVanggewassen"]}
                valuePropName="checked"
              >
                <Switch
                  className={styles.alignSuper}
                  disabled={isKlwReadOnly}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spinal>
      </CardTable.Body>
    </CardTable>
  );
};
